import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './components/AppRoutes';
import { BillingProvider } from './context/BillingContext';
import { AuthProvider } from './context/AuthContext';
import { validateConfig } from './config';

// Import Bootstrap CSS and TriServe CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/main.css';
import './assets/css/tse.css';

const normalizeRouterBasePath = (value) => {
  const raw = (value || '/').trim();
  if (raw === '' || raw === '/') return '/';

  const prefixed = raw.startsWith('/') ? raw : `/${raw}`;
  return prefixed.endsWith('/') ? prefixed.slice(0, -1) : prefixed;
};

const routerBasePath = normalizeRouterBasePath(import.meta.env.VITE_APP_BASE_PATH);

function App() {
  useEffect(() => {
    // Validate configuration on app startup
    try {
      validateConfig();
    } catch (error) {
      console.error('Configuration validation failed:', error);
    }
    
    // Import Bootstrap JavaScript for interactive components
    import('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, []);

  return (
    <Router basename={routerBasePath}>
      <AuthProvider>
        <BillingProvider>
          <AppRoutes />
        </BillingProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
